import {
  UpdateWaitlistMutation,
  UpdateWaitlistMutationVariables,
} from "@outschool/gql-frontend-generated";
import { getQueryNames, gql, useMutation } from "@outschool/ui-apollo";

import { waitlistedClassesQuery } from "../components/parentDashboardV2/queries/waitlistedClassesQuery";
import { ParentWaitlistedClasses } from "../hooks/useWaitlistedClasses";
import { WaitlistSeatsForParent } from "./WaitlistQuery";
import WaitlistSeatFragment from "./WaitlistSeatFragment";

export const updateWaitlistMutation = gql`
  mutation UpdateWaitlist(
    $createInputs: [CreateWaitlistSeatInput!]!
    $deleteInputs: [String!]!
  ) {
    createWaitlistSeats(inputs: $createInputs) {
      ...WaitlistSeatFragment
    }
    deleteWaitlistSeats(uids: $deleteInputs) {
      ...WaitlistSeatFragment
    }
  }

  ${WaitlistSeatFragment}
`;

export function useUpdateWaitlist() {
  return useMutation<UpdateWaitlistMutation, UpdateWaitlistMutationVariables>(
    updateWaitlistMutation,
    {
      refetchQueries: [
        ...getQueryNames([ParentWaitlistedClasses, WaitlistSeatsForParent]),
        waitlistedClassesQuery,
      ],
    },
  );
}
